import { Component, OnInit } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { EmailPreferences, isEmailEnabled } from 'src/app/models/email-preferences.model';
import { User } from 'src/app/models/users.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
const firestore = firebase.firestore;

interface NotificationSetting {
  key: keyof EmailPreferences;
  title: string;
  description: string;
  enabled: boolean;
}

@Component({
  selector: 'app-profile-notifications',
  templateUrl: './profile-notifications.component.html',
})
export class ProfileNotificationsComponent implements OnInit {
  user: User;
  loading = true;

  settings: NotificationSetting[] = [
    {
      key: 'conversionComplete',
      title: 'Conversion complete',
      description:
        'Receive an email when all your statements finish converting successfully. You can always view your results on the dashboard. ' +
        'Emails about failed conversions, corrections, refunds and receipts are always sent.',
      enabled: true,
    },
  ];

  constructor(
    private ss: SharedService,
    private toastr: NbToastrService,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    this.settings.forEach((setting) => (setting.enabled = isEmailEnabled(this.user, setting.key)));
    this.loading = false;
  }

  async onToggle(setting: NotificationSetting, enabled: boolean) {
    const previous = setting.enabled;
    setting.enabled = enabled;

    try {
      await firestore()
        .doc(`users/${this.user.uid}`)
        .update({ [`emailPreferences.${setting.key}`]: enabled });

      this.user.emailPreferences = { ...this.user.emailPreferences, [setting.key]: enabled };
      this.toastr.success(`${setting.title} emails ${enabled ? 'enabled' : 'disabled'}`, 'Saved');
    } catch (error) {
      setting.enabled = previous;
      this.toastr.warning('Failed to save your preference. Please try again.', 'Error');
      console.error(error);
    }
  }
}
